export default __webpack_public_path__ + "static/media/ic_email_black.cd49586a.svg";